module.exports = __webpack_public_path__ + "media/images/design/images/btn_blog-1b2eeea36c191f1aaedd6ed57baf48e1.jpg";